export default __webpack_public_path__ + "static/media/energizer.49640ef5.svg";